module.exports = __webpack_public_path__ + "static/media/open-menu.f676a080.svg";